import { render, staticRenderFns } from "./DepartamentoExport.vue?vue&type=template&id=2aa464ab"
import script from "./DepartamentoExport.vue?vue&type=script&lang=js"
export * from "./DepartamentoExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports